export default "__VITE_ASSET__aLZwXIwE__"